export const categoryTypes = {
    'en': [{
        title: 'Any',
        value: 'all'
    },
    {
        title: 'Condominium Projects',
        value: 'condo'
    },
    {
        title: 'House Projects',
        value: 'house'
    }],
    'th': [{
        title: 'ประเภท',
        value: 'all'
    },
    {
        title: 'คอนโด',
        value: 'condo'
    },
    {
        title: 'บ้าน',
        value: 'house'
    }],    
    'cn': [{
        title: '不限',
        value: 'all'
    },
    {
        title: '公寓',
        value: 'condo'
    },
    {
        title: '别墅',
        value: 'house'
    }],
}